export default "__VITE_ASSET__mvns9vp8__"